/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useEffect, useState} from 'react'
import { InvoiceDetailTable } from "../inoviceDetail/InvoiceDetailTable"
// import jsPDF from "jspdf";
import axios from 'axios';
import Cookies from "js-cookie"
import {
    Paper,
    Tabs,
    Tab,
    Typography
  } from "@material-ui/core";
  import PropTypes from "prop-types";
  import { useLocation } from 'react-router-dom';
import { NODE_API_URL,BASE_URL } from '../../../../env_config';
import ProformaSkeleton from './ProformaSkeleton'
import { BsArrowLeftShort } from "react-icons/bs";
import moment from "moment-timezone";
import { MdOutlineEmail } from 'react-icons/md';
import { FaRegFilePdf } from 'react-icons/fa';
import getSymbolFromCurrency from 'currency-symbol-map';

  function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };

export const ProformaDetails = (props) => {
    const [value, setValue] = React.useState(0); // for tab

    function handleTabChange(event, newValue) {
        setValue(newValue);
    }
    const location = useLocation()
    function numberWithCommas(x) {
        if (x) {
            return parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "0.00";
        }
    }
    const [performadata,setPerformaData] = useState()
    useEffect(() => {
        if(location.state.query){
            const finalData = {
                "id":location.state.query.perfoma_no
            }
            axios({
                method: "get",
                url: `${NODE_API_URL}/INTL/get-proforma-details`,
                headers: {
                    "Content-Type": "application/json",
                     "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                },
                params: finalData,
            }).then(res => {
                if(res && res.data){
                    // console.log(res.data,"DATATATAA")
                    setPerformaData(res.data)
                }
            }).catch(error => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                  var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                  if(cookies[i] && !cookies[i].includes("view")){
                    var equals = cookies[i].indexOf("=");
                    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                  }
                }
                
                window.location.replace(`${BASE_URL}/logout`);
              }
              })
        }
    },[])
    const converttoyhmd = (newdate) => {
        let date = new Date(newdate) //10 May 2019, 3:30:20 PM
        let d = date.getUTCDate().toString().padStart(2, '0'); // Two-digit day
        let m = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Two-digit month
        let y = date.getUTCFullYear().toString().substr(-2); // Last two digits of the year

        let H = date.getUTCHours().toString().padStart(2, '0'); // Two-digit hour
        let i = date.getUTCMinutes().toString().padStart(2, '0'); // Two-digit minute
        let s = date.getUTCSeconds().toString().padStart(2, '0'); // Two-digit second

        let ymdHms = y + m + d + H + i + s;
        // setYmdHms(ymdHms)
        return ymdHms
    }

    const handleGeneratePdf = () => {
        window.open(performadata.pdf_link, "_blank")

    }
    const SendEmail = () => {
        if(performadata && performadata.expand && performadata.expand.length > 0){
            const finalData = {
                "proforma_no":location.state.query.perfoma_no,
                "conform_good_id":location.state.query.conform_good_id.split(',')
            }
            axios({
                method: "get",
                url: `${NODE_API_URL}/INTL/sendProfomaEmail`,
                headers: {
                    "Content-Type": "application/json",
                     "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                },
                params:finalData
            }).then(res => {
                if(res && res.data){
                    if(res.data.success){
                        alert("Mail Sent")
                    }
                }
            }).
            catch(error => {
              if(error?.response?.data?.message === "UnAuthorized!"){
                var cookies = document.cookie.split(";");
              for (var i = 0; i < cookies.length; i++) {
                if(cookies[i] && !cookies[i].includes("view")){
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              
              window.location.replace(`${BASE_URL}/logout`);
            }
            })
        }
    }
    const getaddress = () => {
        let shippingaddress = ""
        let billingaddress = ""
        if(performadata){
            if(performadata.company_name_official){
                shippingaddress += "<p><b>"
                shippingaddress += performadata.company_name_official
                shippingaddress += "</b></p>"
            }
            if(performadata?.name_atten){
                shippingaddress += "<p><b>"
                shippingaddress += performadata?.name_atten
                shippingaddress += "</b></p>"
            }
            if(performadata?.shipping_address_1){
              shippingaddress += "<p>"
              shippingaddress += performadata?.shipping_address_1 + ","
              shippingaddress += "</p>"
            }
            if(performadata?.shipping_address_2){
                shippingaddress += "<p>"
                shippingaddress += performadata?.shipping_address_2 + ","
                shippingaddress += "</p>"
            }
            if(performadata?.shipping_address_3){
                shippingaddress += "<p>"
                shippingaddress += performadata?.shipping_address_3 + ","
                shippingaddress += "</p>"
            }
            shippingaddress += "<p>"
            shippingaddress += performadata?.shipping_city + ", "
            if(performadata?.shipping_state){
                shippingaddress += performadata?.shipping_state + ", "
            }
            if(performadata?.shipping_zip_code){
                shippingaddress += performadata?.shipping_zip_code + ", "
            }
            shippingaddress += "</p>"
            if(performadata?.shipping_country){
                shippingaddress += "<p>"
                shippingaddress += performadata?.shipping_country
                shippingaddress += "</p>"
            }
            if(performadata?.fedex_ac_no){
                shippingaddress += "<p>Fedex Ac No:"
                shippingaddress += performadata?.fedex_ac_no
                shippingaddress += "</p>"
            }
            if(performadata?.shipping_email){
                shippingaddress += "<p>Email:"
                shippingaddress += performadata?.shipping_email
                shippingaddress += "</p>"
            }
            if(performadata?.shipping_phone){
                shippingaddress += "<p>Phone:"
                shippingaddress += performadata?.shipping_phone
                shippingaddress += "</p>"
            }
        
            
        
            if(performadata.company_name_official){
                billingaddress += "<p><b>"
                billingaddress += performadata.company_name_official
                billingaddress += "</b></p>"
            }
            if(performadata.address){
              billingaddress += "<p>"
              billingaddress += performadata.address + ","
              billingaddress += "</p>"
            }
            if(performadata.secaddress){
                billingaddress += "<p>"
                billingaddress += performadata.secaddress + ","
                billingaddress += "</p>"
            }
            if(performadata.addressline3){
                billingaddress += "<p>"
                billingaddress += performadata.addressline3 + ","
                billingaddress += "</p>"
            }
            billingaddress += "<p>"
            billingaddress += performadata?.city + ", "
            if(performadata?.state){
                billingaddress += performadata?.state + ", "
            }
            if(performadata?.com_zip){
                billingaddress += performadata?.com_zip + ","
            }
            billingaddress += "</p>"
            if(performadata.country){
                billingaddress += "<p>"
                billingaddress += performadata.country
                billingaddress += "</p>"
            }
            if(performadata.company_tax){
                billingaddress += `<p><b>${performadata.company_tax_name}:</b>`
                billingaddress += performadata.company_tax
                billingaddress += "</p>"
            }
            if(performadata.com_reg_no){
                billingaddress += `<p><b>${performadata.com_reg_no_name}:</b>`
                billingaddress += performadata.com_reg_no
                billingaddress += "</p>"
            }
        }
        return{
            shippingaddress:shippingaddress,
            billingaddress:billingaddress
        }
}
    return (
        <>
        
        {performadata? <>
            <div className="row bg-white rounded m-0 border-left-primary mb-5">
                <div className="col-12 px-5 py-2">
                    <span className="mb-0 font-size-h2 font-weight-bold d-block text-dark">{props.language.PROFORMA_DETAIL_DOCLLP}</span>
                    {/* <span className="text-muted">This page hase been enhanced for printing</span > */}
                </div>
            </div>
            <div className="card custom-card border-0 gutter-b">
                <div className="card-header bg-transparent border-0 py-3 px-5 d-flex justify-content-between align-items-center border-bottom-0">
                    <div className="card-title mb-0 ">
                        <span className="font-size-h2 font-weight-bold d-block">{props.language.PROFORMA_DETAIL_PROFORMA_INVOICE_DETAILS}: #{performadata.proformasku}</span>
                        <span className="text-muted d-block">
                            {props.language.PROFORMA_DETAIL_PROFORMA_INVOICED_ON} 
                            {/* {performadata.performadate} */}{" "}
                            { performadata.proformaDate}
                            </span >
                    </div>
                    <div className="card-toolbar">
                        <span className="btn btn-text-dark btn-hover-light-dark  mr-3"onClick={() =>window.history.go(-1)}><BsArrowLeftShort className='mr-2 font-size-h5'/> {props.language.BACK}</span>
                        <button className="btn btn-text-dark btn-hover-light-primary  mr-3" onClick={SendEmail}><MdOutlineEmail className='mr-2 font-size-h5'/>{props.language.PROFORMA_DETAIL_SEND_EMAIL}</button>
                        <button className="btn btn-text-dark btn-hover-light-danger " onClick={handleGeneratePdf}><FaRegFilePdf className='mr-2 font-size-h5'/>{props.language.PROFORMA_DETAIL_SEND_PDF}</button>
                    </div>
                </div>
                <div className="card-body bg-white p-0 pb-8">
                    <Paper position="static" className="shadow-none border-bottom">
                        <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={handleTabChange}>
                            <Tab label={props.language.PROFORMA_DETAIL_DETAILS} />
                            {/* <Tab label="History" disabled /> */}
                            {/* <Tab label="Additional Details"/> */}
                        </Tabs>
                    </Paper>
                     {value === 0 && (
                        <TabContainer >
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="font-size-h4  mb-2">{props.language.PROFORMA_DETAIL_SHIPPING_ADDRESS}</div>
                                    <div>
                                        {getaddress().shippingaddress ?  <div className="invAddress" dangerouslySetInnerHTML={ {__html:  getaddress().shippingaddress} } />: '-'}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="font-size-h4 font-weight-bold  mb-2">{props.language.PROFORMA_DETAIL_BILLING_ADDRESS}</div>
                                    <div>
                                        {getaddress().billingaddress?  <div className="invAddress" dangerouslySetInnerHTML={ {__html:  getaddress().billingaddress} } />:  '-'}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="font-size-h4 font-weight-bold mb-2">{props.language.PROFORMA_DETAIL_LOGISTICS_INFORMATION}</div>
                                    <div className="">{props.language.PROFORMA_DETAIL_CARRIER} :{performadata.shippingName}</div>
                                    {/* <div className="">{props.language.PROFORMA_DETAIL_TRACKING} :N/A</div> */}

                                    {/* <a href='#' target="_blank" rel='referal'>{props.language.PROFORMA_DETAIL_TRACK_YOUR_PACKAGE}</a> */}
                                </div>
                                <div className="col-md-3">
                                    <div className="font-size-h4 font-weight-bold mb-2">{props.language.PROFORMA_DETAIL_ORDER_SUMMARY}</div>
                                    <div className="row">
                                        <div className="col-12 d-flex justify-content-between">
                                            <span>{props.language.PROFORMA_DETAIL_DIAMONDS}:</span>
                                            <span>{performadata.totalDiamondCount} {props.language.PROFORMA_DETAIL_PCS}</span>
                                        </div>
                                        <div className="col-12 d-flex justify-content-between">
                                            <span>{props.language.SEARCHLIST_TOTALCARAT}:</span>
                                            <span>{numberWithCommas(performadata.totalCarat)}</span>
                                        </div>
                                        <div className="col-12 d-flex justify-content-between">
                                            <span>{props.language.SEARCHGRID_TOTAL} {performadata.totalDiamondPriceSymbolName}/CT:</span>
                                            <span>{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.totalDiamondRate)}</span>
                                        </div>
                                        <div className="col-12 d-flex justify-content-between">
                                            <span>Total Price {performadata.totalDiamondPriceSymbolName}:</span>
                                            <span>{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.totalDiamondPrice)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabContainer>
                    )}
                    {value === 1 && (
                        <TabContainer >
                            2
                        </TabContainer>
                    )}
                </div>
            </div>

            <div className="card custom-card  border-0 gutter-b">
                <div className="card-header bg-transparent py-5 border-bottom-0">
                    <div className="card-title mb-0 font-size-h4 font-weight-bold">{props.language.PROFORMA_DETAIL_DIAMONDS_INFORMATION}</div>
                </div>
                <div className="card-body p-8 rounded bg-white">
                    <InvoiceDetailTable diamonddetail={performadata.expand} userinfo={props.userinfo} language={props.language}/>
                    <div className="row p-5 mt-5">
                        <div className="col-md-7">
                           
                        </div>
                        <div className="col-md-5">
                            <table className='table'>
                                <tr>
                                    <td className="font-size-h5">{props.language.INVOICE_DIAMOND_PRICE}:</td>
                                    <td className="font-size-h5 text-right">
                                        {performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.totalDiamondPrice)}
                                        <div className='small text-muted'>{performadata.totalDiamondPriceSymbol}/CT{numberWithCommas(performadata.totalDiamondRate)}</div>
                                    </td>
                                    {performadata.totalDiamondExchangePriceSymbolName ?
                                        <td className="font-size-h5 text-right">
                                           {performadata.totalDiamondExchangePriceSymbol}{numberWithCommas(performadata.totalDiamondExchangePrice)}
                                            <div className='small text-muted'>{performadata.totalDiamondExchangePriceSymbolName}/CT {numberWithCommas(performadata.totalDiamondExchangeRate)}</div>
                                        </td>
                                    :null}
                                </tr>
                                {performadata.extraChargesOrDiscount?
                                <tr>
                                    <td className="font-size-h5">{performadata.extraChargesOrDiscount>0?props.language.INVOICE_EXTRA_CHARGES:props.language.INVOICE_DISCOUNT}:</td>
                                    <td className="font-size-h5 text-right">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.extraChargesOrDiscount)}</td>
                                    {performadata.totalDiamondExchangePriceSymbolName ?
                                        <td className="font-size-h5 text-right">{ performadata.totalDiamondExchangePriceSymbol}{numberWithCommas(performadata.extraChargesOrDiscountExchange)}</td>
                                    :null}
                                </tr>:null}
                                {performadata.shippingCharge?<tr className="">
                                    <td className="font-size-h5">{props.language.REQ_DIAMOND_CONVINIENCE_FEE}:</td>
                                    <td className="font-size-h5  text-right">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.shippingCharge)}</td>
                                    {performadata.totalDiamondExchangePriceSymbolName ?
                                        <td className="font-size-h5  text-right">{ performadata.totalDiamondExchangePriceSymbol}{numberWithCommas(performadata.shippingChargeExchange ? performadata.shippingChargeExchange:"00")}</td>
                                    :null}
                                </tr>:""}
                                {performadata.indiacgst?<tr>
                                    <td className="font-weight-bold font-size-h5">CGST({performadata.indiacgstrate})</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.indiacgst)}</td>
                                </tr>:""}
                                {performadata.indiasgst?<tr>
                                    <td className="font-weight-bold font-size-h5">SGST({performadata.indiasgstrate})</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.indiasgst)}</td>
                                </tr>:""}
                                {performadata.indiaigst?<tr>
                                    <td className="font-weight-bold font-size-h5">IGST({performadata.indiaigstrate})</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.indiaigst)}</td>
                                </tr>:""}
                                {performadata.chargetax?<tr>
                                    <td className="font-weight-bold font-size-h5">Charge Tax({performadata.chargetaxrate})</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.chargetax)}</td>
                                </tr>:""}
                                {performadata.australiagst?<tr>
                                    <td className="font-weight-bold font-size-h5">GST({performadata.australiagstrate})</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.australiagst)}</td>
                                </tr>:""}
                                <tr>
                                    <td className="font-weight-bold font-size-h5">{props.language.REQ_TOTAL_DIAMOND_PRICE}</td>
                                    <td className="font-weight-bold  text-right font-size-h5">{performadata.totalDiamondPriceSymbol}{numberWithCommas(performadata.totalDiamondPriceProfoma ? performadata.totalDiamondPriceProfoma :"00")}</td>
                                    {performadata.totalDiamondExchangePriceSymbolName ?
                                        <td className="font-weight-bold  text-right font-size-h5">{ performadata.totalDiamondExchangePriceSymbol}{numberWithCommas(performadata.totalDiamondPriceProfomaExchange)}</td>
                                    :null}
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

                <div className="card bg-white">
                <div className="card-body">
                    <div className="row">

                    {performadata?.bankdetails && (
                        <div className="col">
                        <div className="font-size-h4 font-weight-bold mb-2">
                            {performadata.bankheader}
                        </div>
                        <div className="font-size-lg">
                            {performadata.bankdetails.split("\n").map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                            ))}
                        </div>
                        </div>
                    )}

                    {performadata?.bankdetailsother && (
                        <div className="col">
                        <div className="font-size-h4 font-weight-bold mb-2">
                            {performadata.bankheaderother}
                        </div>
                        <div className="font-size-lg">
                            {performadata.bankdetailsother.split("\n").map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                            ))}
                        </div>
                        </div>
                    )}

                    {/* TERMS — ALWAYS */}
                    <div className="col">
                        <div className="font-size-h4 font-weight-bold mb-3">
                        {props.language.PROFORMA_DETAIL_TERMS}
                        </div>
                        <div className="font-size-lg mb-3">
                        {props.language.PROFORMA_DETAIL_TERMS1}
                        </div>
                        <div className="font-size-lg mb-3">
                        {props.language.PROFORMA_DETAIL_TERMS2}
                        </div>
                        <div className="font-size-lg mb-3">
                        {props.language.PROFORMA_DETAIL_TERMS3}
                        </div>
                    </div>

                    </div>
                </div>
                </div>

            </>:<ProformaSkeleton /> }
        </>
    )
}